<template>
  <div>
    <el-input v-model="filterText" :clearable="true" :placeholder="placeholder"></el-input>
    <el-tree
      :data="treeData"
      :props="defaultProps"
      node-key="id"
      :show-checkbox="checkable"
      highlight-current
      :filter-node-method="filterNode"
      :default-expand-all="true"
      @show="clearFilter"
      @check="handleCheck"
      @node-click="handleNodeClick"
      ref="tree">
      <span slot-scope="{ node, data }" :class="{'disabled-text' : data.disable}">
        {{data.name}}
      </span>
    </el-tree>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import isCRMUser from '@util/isCRMUser';

  export default {
    props: [
      'placeholder'
    ],
    data () {
      return {
        checkable: this.$attrs.checkable === undefined || this.$attrs.checkable,
        filterText: '',
        currentKeys: [],
        treeData: [],
        defaultProps: {
          children: 'children',
          label: 'name',
          disabled: 'disable'
        },
        defaultCheckedKeys: []
      };
    },
    computed: {
      ...mapState(['orgTree'])
    },
    created () {
      this.initTree(this.orgTree);
    },
    methods: {
      initTree (agencyList) {
        let root = isCRMUser() ? agencyList[0] : agencyList[agencyList.length - 1];
        root.children = this.findChild(agencyList, root.id);
        this.treeData = [root];
      },
      findChild (list, rootId) {
        const map = {};
        list.forEach((item) => {
          item.children = [];
          map[item.id] = item;
        });
        list.forEach((item) => {
          if (map[item.pid]) {
            map[item.pid].children.push(item);
          }
        });
        const ret = [];
        for (var i in map) {
          if (map[i].pid === rootId) {
            ret.push(map[i]);
          }
        }
        return ret;
      },
      clearFilter () {
        this.filterText = '';
      },
      filterNode (value, data) {
        if (!value) {
          return true;
        }
        return data.name.indexOf(value) !== -1;
      },
      handleCheck (data, { checkedKeys, checkedNodes }) {
        let leafNodes = checkedNodes.filter((node) => {
          if (isCRMUser()) {
            return node.type === 3;
          } else {
            return node.children && node.children.length === 0 && node.type === 4;
          }
        });
        this.currentKeys = leafNodes;
        this.$emit('checkedChange', leafNodes);
      },
      handleNodeClick (data) {
        this.$emit('node-text-click', data);
        if (!this.checkable) {
          this.$emit('nodeClick', data);
        }
      },
      setAgency (agencies) {
        if (this.checkable) {
          agencies = agencies || [];
          this.$refs.tree.setCheckedKeys(agencies);
        } else {
          if (agencies === undefined) {
            this.$emit('nodeClick');
            this.$refs.tree.store.currentNode = null;
          } else {
            let curNode = this.$refs.tree.store.nodesMap[agencies].data;
            this.$emit('nodeClick', curNode);
          }
        }
      },
      setAgencyByHotelId (hotelId) {
        let agencies = this.getIdByHotelId(hotelId);
        if (this.checkable) {
          agencies = agencies || [];
          this.$refs.tree.setCheckedKeys(agencies);
        } else {
          if (agencies === undefined) {
            this.$emit('nodeClick');
            this.$refs.tree.store.currentNode = null;
          } else {
            let curNode = this.$refs.tree.store.nodesMap[agencies].data;
            this.$emit('nodeClick', curNode);
          }
        }
      },
      getData () {
        return {
          data: this.orgTree,
          tree: this.treeData
        };
      },
      getIdByHotelId (hotelId) {
        let item = this.orgTree.filter(item => +item.hotelId === +hotelId);
        if (item.length > 0) {
          return item[0].id;
        } else {
          return undefined;
        }
      },
    },
    watch: {
      filterText (val) {
        this.$refs.tree.filter(val);
      },
    }
  };
</script>

<style lang="less">
  .el-tree {
    overflow: auto;
    max-height: 300px;
    .disabled-text {
      color: #909399;
      cursor: not-allowed;
    }
  }
</style>



// WEBPACK FOOTER //
// AgencyTreeCore.vue?48d7c376